import { render } from "./ReportedWebsites.vue?vue&type=template&id=7bb640d2&scoped=true"
import script from "./ReportedWebsites.vue?vue&type=script&lang=js"
export * from "./ReportedWebsites.vue?vue&type=script&lang=js"

import "./ReportedWebsites.vue?vue&type=style&index=0&id=7bb640d2&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/xsurflog_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bb640d2"]])

export default __exports__